/* eslint-disable */
import axios from 'axios';
import { IImage } from '@/shared/model/image.model'; // SPE
// import axios from '@/api/http-common' // SPE
//
// import { IImage } from '@/shared/model/employee-image.model';

const baseApiUrl = 'api/employee-images';

export default class EmployeeImageService {
  /**
   * Replaces src/api/services/employee.service.ts#getEmployeeImage
   */
  public find(id: string): Promise<IImage> {
    return new Promise<IImage>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IImage): Promise<IImage> {
    return new Promise<IImage>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IImage): Promise<IImage> {
    return new Promise<IImage>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IImage): Promise<IImage> {
    return new Promise<IImage>((resolve, reject) => {
      axios
        .patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
